export interface IDroppedItem {
  combine: null;
  destination: {
    droppableId: string;
    index: number;
  };
  draggableId: string;
  mode: string;
  reason: string;
  source: {
    droppableId: string;
    index: number;
  };
  type: string;
}

export enum LayerTypes {
  SIMPLE = 'SIMPLE',
  GROUP = 'GROUP',
  CHILD = 'CHILD',
}
